module.exports = __webpack_public_path__ + "img/HA2506-150.b46c2e9c.jpg";